import React from 'react';
import { Sentry } from '../utils/sentry';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info?.componentStack);
    // Report to Sentry if configured (no-op if no DSN)
    try {
      Sentry.captureException(error, { contexts: { react: { componentStack: info?.componentStack } } });
    } catch {}
  }

  handleReload = () => {
    try {
      // Clear potentially-corrupt local state but keep auth
      const keep = ['firebase:authUser'];
      const preserved = {};
      keep.forEach(prefix => {
        Object.keys(localStorage).forEach(k => {
          if (k.startsWith(prefix)) preserved[k] = localStorage.getItem(k);
        });
      });
      localStorage.clear();
      Object.entries(preserved).forEach(([k, v]) => localStorage.setItem(k, v));
    } catch {}
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.href = '/';
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="error-boundary-page">
        <div className="error-boundary-card">
          <div className="error-boundary-icon">⚠️</div>
          <h1>Algo salió mal</h1>
          <p>
            Tuvimos un problema cargando esta vista. No te preocupes, tus láminas están a salvo en la nube.
          </p>
          {this.state.error?.message && (
            <details className="error-boundary-details">
              <summary>Detalles técnicos</summary>
              <code>{this.state.error.message}</code>
            </details>
          )}
          <div className="error-boundary-actions">
            <button className="btn btn-gold" onClick={this.handleReload}>
              🔄 Reintentar
            </button>
            <button className="btn" onClick={this.handleGoHome}>
              Ir al inicio
            </button>
          </div>
        </div>
      </div>
    );
  }
}
